import api from '../utils/request'

export default {
  // 获取token
  getTokenApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/common/GetAuthorToken',
      data: data
    })
  },
  // 邮箱登录接口
  checkEmailLoginApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/visitor/CheckEmailLogin',
      data: data
    })
  },
  // 基本信息保存
  visitorSaveApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Visitor/SaveVisitor',
      data: data
    })
  },
  // 获取问卷
  getAnswersApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Questions/GetAnswers',
      data: data
    })
  },
  // 提交问卷
  saveAwsApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Visitor/SaveVisitorAnws',
      data: data
    })
  },
  // 获取成功页信息
  getVisitorApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/visitor/GetSuccessVisitorInfo',
      data: data
    })
  },
  // 获取短信验证码
  getSmsCodeApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/common/GetSmsCode',
      data: data
    })
  },
  // 创建展商
  cActorApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/actor/CreateActorInfo',
      data: data
    })
  },
  // 获取微信签名
  getsignatureApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Wechat/Getsignature',
      data: data
    })
  },
  // 根据openid判断是否注册过
  checkIdentityLoginApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Visitor/CheckIdentityLogin',
      data: data
    })
  },
  // 获取会议详情
  getActiviInfoApi(data) {
    return api({
      method: 'POST',
      url: 'Medic/GetActiviInfo',
      data: data
    })
  },
  // huoququanjuepeizhi
  getGConfig(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Configuation/GetGloabalConfiguar',
      data: data
    })
  },
  // 图片上传
  uploadApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/image/Upload',
      data: data
    })
  },
  // 获取展商
  getActorApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/actor/GetActorInfoByEncrycode',
      data: data
    })
  },
  // 查询展商信息 /actor/GetActorByBthCode
  getActorByBthCodeApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/actor/GetActorByBthCode',
      data: data
    })
  },
  // 展品列表
  /**
   * @param {*} data
   * @returns
   */
  GetElectronicListApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Electronic/GetElectronicList',
      data: data
    })
  },
  // 展品详情
  GetElectronicinfoApi(data) {
    return api({
      method: 'POST',
      url: 'BackCenter/Electronic/GetElectronicinfo',
      data: data
    })
  }
}
